import { Colors } from '@sigma-frontend-libs/commons'

import { icons } from '@/utils'

import render from './render'

export default {
  name: 'Info',

  props: {
    value: String,

    icon: {
      type: String,
      default: icons.info_outline,
      validator: value => {
        return Object.values(icons).includes(value)
      }
    },

    iconSVG: {
      type: String,
      default: undefined
    },

    color: {
      type: String,
      default: Colors.info,
      validator: value => {
        return Object.values(Colors).includes(value)
      }
    },

    rounded: {
      type: Boolean,
      default: true
    },

    button: {
      type: Object,
      default: undefined
    }
  },

  computed: {
    class() {
      return {
        ['info']: true,
        [`info--${this.color}`]: !!this.color,
        ['info--rounded']: this.rounded
      }
    },

    hasContent() {
      return !!this.value || this.$slots.default
    },

    hasButton() {
      return !!this.button
    }
  },

  methods: {
    buttonClickHandler(event) {
      if (typeof this.button?.callback === 'function') {
        return this.button.callback(event)
      }
    }
  },

  render
}
